import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: #111;
  color: white;
  padding: 3rem 2rem 2rem;
  
  @media (max-width: 768px) {
    padding: 2rem 1rem 1.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 1.5rem 1rem 1rem;
  }
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 3rem;
  
  @media (max-width: 968px) {
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
  }
`;

export const LeftContainer = styled.div`
  flex: 1;
  max-width: 320px;
  
  @media (max-width: 768px) {
    max-width: 100%;
    order: 1;
  }
`;

export const MiddleContainer1 = styled.div`
  flex: 0 0 auto;
  min-width: 180px;
  
  @media (max-width: 768px) {
    order: 2;
  }
`;

export const MiddleContainer2 = styled.div`
  flex: 0 0 auto;
  min-width: 200px;
  
  @media (max-width: 768px) {
    order: 3;
  }
`;

export const RightContainer = styled.div`
  flex: 1;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  @media (max-width: 768px) {
    max-width: 100%;
    order: 4;
  }
`;

export const LogoWrapper = styled.div`
  margin-bottom: 1rem;
  
  img {
    height: 35px;
  }
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

export const CompanyInfo = styled.div`
  font-size: 0.85rem;
  opacity: 0.7;
  line-height: 1.4;
  
  p {
    margin-bottom: 0.2rem;
  }
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const LinkItem = styled.li`
  margin-bottom: 0.6rem;
  
  a {
    color: white;
    opacity: 0.8;
    text-decoration: none;
    transition: opacity 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      opacity: 1;
    }
  }
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const SocialText = styled.p`
  font-size: 0.9rem;
  margin-bottom: 1rem;
  opacity: 0.8;
  text-align: center;
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  justify-content: center;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    color: white;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      transform: translateY(-2px);
    }
    
    svg {
      fill: white;
    }
  }
`;

export const CopyrightText = styled.p`
  text-align: center;
  font-size: 0.8rem;
  opacity: 0.6;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  
  @media (max-width: 768px) {
    margin-top: 1rem;
    padding-top: 1rem;
  }
`;



export const WhatsAppButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25D366;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  z-index: 999;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
    }
  }
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(37, 211, 102, 0.7);
    animation: none;
  }
  
  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
    bottom: 1.5rem;
    right: 1.5rem;
  }
  
  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    bottom: 1rem;
    right: 1rem;
  }
  
  svg {
    width: 28px;
    height: 28px;
    
    @media (max-width: 480px) {
      width: 24px;
      height: 24px;
    }
  }
`;

export const WhatsAppTooltip = styled.div`
  position: absolute;
  bottom: 70px;
  right: 0;
  background-color: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  
  animation: tooltipLoop 4s infinite;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 15px;
    border: 5px solid transparent;
    border-top-color: #333;
  }
  
  @keyframes tooltipLoop {
    0%, 25% {
      opacity: 0;
      transform: translateY(10px);
    }
    30%, 70% {
      opacity: 1;
      transform: translateY(0);
    }
    75%, 100% {
      opacity: 0;
      transform: translateY(10px);
    }
  }
  
  @media (max-width: 768px) {
    bottom: 65px;
    font-size: 11px;
    padding: 6px 10px;
  }
  
  @media (max-width: 480px) {
    bottom: 60px;
    font-size: 10px;
    padding: 5px 8px;
    right: -10px;
  }
`;